import React, { lazy } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
// import common components
import SuspenseWrapper from "../../common-components/SuspenseWrapper";
import Typography, { TYPE_ELEMENTS } from "../../common-components/Typography";
import Banner from "../../common-components/Banner";
import TabbedCardWide from "../../common-components/cards/TabbedCardWide";
// import ImageCardOverlay from "../../common-components/cards/ImageCardOverlay";
// import common styles
import PageContentWrapper from "../../common-styles/PageContentWrapper";
// import constants
import CONSTANTS from "../../utils/constants/constants";
import APPLICATIONS_CONSTANTS from "../../utils/constants/applicationsConstants";

const { BANNER, MAIN, KNOW_MORE } = APPLICATIONS_CONSTANTS;

const ImageCardOverlay = lazy(() =>
  import("../../common-components/cards/ImageCardOverlay")
);
// const TabbedCardWide = lazy(() =>
//   import("../../common-components/cards/TabbedCardWide")
// );

const ApplicationsWrapper = styled.div`
  width: 100%;
  height: fit-content;
  color: #fff;
`;

const MoreTechSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 72px;
  width: 100%;
  padding: 32px 0px;
  text-align: center;

  @media (max-width: 1280px) {
    gap: 48px;
  }
`;

const MoreTechList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 1400px) {
    gap: 48px;
  }

  @media (max-width: 1280px) {
    gap: 24px;
  }

  @media (max-width: 1100px) {
    gap: 20px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    flex-wrap: nowrap;
  }
`;

export default function Applications() {
  React.useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      const element = document.querySelector(window.location.hash);
      if (element) {
        // Wait for next tick to ensure component is rendered
        setTimeout(() => {
          const offset = 180; // Adjust this value to control distance from top
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }, 0);
      }
    }
  }, []); // Run only on mount

  return (
    <>
      <Helmet>
        <title>Use Cases | Sisir Radar</title>
        <meta
          name="description"
          content="Defence, Agriculture, Mining, Urban Planning, and Environment—explore how Sisir Radar's world-class SAR, GPR, and Hyperspectral systems deliver unmatched situational awareness and precision monitoring across multiple domains, playing a massive role in transforming Earth Observation and Remote Sensing."
        />
        <meta
          property="og:title"
          content="Use Cases | Sisir Radar"
        />
        <meta
          property="og:description"
          content="Defence, Agriculture, Mining, Urban Planning, and Environment—explore how Sisir Radar's world-class SAR, GPR, and Hyperspectral systems deliver unmatched situational awareness and precision monitoring across multiple domains, playing a massive role in transforming Earth Observation and Remote Sensing."
        />
        <meta property="og:image" content={BANNER.IMG} />
      </Helmet>
      <ApplicationsWrapper>
        <Banner
          img={BANNER.IMG}
          headers={BANNER.HEADER}
          alt={BANNER.ALT}
          opacity={0.4}
        />
        <PageContentWrapper>
          {MAIN.map((content, i) => {
            const { TITLE, IMG, ALT, BODY, TABS, LIST } = content;

            return (
              <TabbedCardWide
                id={TITLE.toLocaleLowerCase().replaceAll(" ", "-")}
                img={IMG}
                alt={ALT}
                title={TITLE}
                bodyTexts={BODY}
                tabs={TABS}
                isReverse={!!(i % 2 === 0)}
                isListed={
                  TITLE.toLocaleLowerCase().includes("defence") ? "SAR" : null
                }
              />
            );
          })}
          <MoreTechSection>
            <Typography typeElement={TYPE_ELEMENTS.H_3} isOutline={"true"}>
              {CONSTANTS.KNOW_MORE.toUpperCase()}
            </Typography>
            <MoreTechList>
              {KNOW_MORE.map((tech, i) => (
                <SuspenseWrapper key={i}>
                  <ImageCardOverlay
                    img={tech.IMG}
                    alt={tech.ALT}
                    title={tech.TITLE}
                    link={tech.LINK}
                  />
                </SuspenseWrapper>
              ))}
            </MoreTechList>
          </MoreTechSection>
        </PageContentWrapper>
      </ApplicationsWrapper>
    </>
  );
}
